

//set favicon
export function setFavicon(url) {
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.href = url;

    document.getElementsByTagName("head")[0].appendChild(link);
}

export function capitalizeFirst(inputString) {
    if (inputString) {
        // Convert the entire string to lowercase
        const lowercasedString = inputString.toLowerCase();

        // Capitalize the first letter
        const capitalizedString = lowercasedString.charAt(0).toUpperCase() + lowercasedString.slice(1);

        return capitalizedString;
    }
}

//currency seperator
export const currencyseperator = (amount) => {
    return amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0.00;
}
